/**
 * 🔐 SIMPLE AUTH MANAGER (NO AUTO EXPIRY)
 * This CANNOT show "session expired" by itself
 */

import { Alert } from 'components'

const TOKEN_KEY = 'authorization'
const USER_KEY = 'userData'

// ================= TOKEN =================
export const getAuthToken = () => {
  return localStorage.getItem(TOKEN_KEY)
}

export const setAuthToken = (token) => {
  if (!token) return false
  localStorage.setItem(TOKEN_KEY, token)
  return true
}

export const isUserAuthenticated = () => {
  return !!localStorage.getItem(TOKEN_KEY)
}

// ================= USER =================
export const getAuthUserData = () => {
  try {
    const data = localStorage.getItem(USER_KEY)
    return data ? JSON.parse(data) : null
  } catch {
    return null
  }
}

export const setAuthUserData = (data) => {
  if (!data) return false
  localStorage.setItem(USER_KEY, JSON.stringify(data))
  return true
}

// ================= CLEAR =================
export const clearAuthData = () => {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USER_KEY)
}

// ================= AUTH HOOK =================
export const useAuth = () => {
  const login = async (credentials) => {
    try {
      const { default: api } = await import('../api')
      const res = await api.auth.user.logIn(credentials)

      if (res.code === 201) {
        setAuthToken(res.payload.authorization)
        setAuthUserData(res.payload.userData)
        Alert.success('Login successful')
        return { success: true }
      }

      Alert.error(res.message || 'Login failed')
      return { success: false }
    } catch (e) {
      Alert.error('Login failed')
      return { success: false }
    }
  }

  const logout = () => {
    clearAuthData()
    Alert.success('Logged out successfully')
    window.location.href = '/login'
  }

  return {
    login,
    logout,
    isAuthenticated: isUserAuthenticated(),
    getToken: getAuthToken,
    getUserData: getAuthUserData
  }
}

export default {
  useAuth,
  getAuthToken,
  setAuthToken,
  isUserAuthenticated,
  getAuthUserData,
  setAuthUserData,
  clearAuthData
}


